import {
  Component,
  OnInit,
  QueryList,
  ElementRef,
  ViewChildren,
  ViewChild,
  OnDestroy,
  TemplateRef,
  Input,
  OnChanges,
  ChangeDetectorRef,
  model,
  Output,
  EventEmitter,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { Product } from "../../../shared/models/product.model";
import { CoreService } from "../../../shared/services/core.service";
import {
  Basket,
  mix_matchrequest,
  mix_match_response,
} from "../../../shared/models/baske.model";
import { BasketItem } from "../../../shared/models/basketitem.model";
import { Store, select } from "@ngrx/store";
import { IAppState } from "../../../store/states/app.state";
import {
  GetProduct,
  GetSingleProduct,
} from "../../../store/actions/product.actions";
import {
  selectProduct,
  selectProductList,
} from "../../../store/selectors/product.selector";
import { OpenAboutBasketComponent } from "src/app/shared/commonComponent/OpenAbout_Basket/OpenAbout_Basket.component";
import { ProductPagemodel } from "src/app/shared/pageModels/productPage";
import { ProductList } from "src/app/shared/models/productlist.model";
import { ConfirmationDialogService } from "src/app/shared/commonComponent/confirmation-dialog/confirmation-dialog.service";
import { NgImageSliderModule } from "ng-image-slider";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { OpenAboutBasketComponent as OpenAboutBasketComponent_1 } from "../../../shared/commonComponent/OpenAbout_Basket/OpenAbout_Basket.component";
import { NgStyle, NgClass, AsyncPipe, DecimalPipe } from "@angular/common";
import { Subscription } from "rxjs";
import { MessagePopupComponent } from "src/app/shared/commonComponent/MessagePopup/MessagePopup.component";
import { ExtraproductComponent } from "./Extra_product/extraproduct.component";
import { PopupLoginComponent } from "src/app/auth/popup-login/popup-login.component";
import { User } from "src/app/shared/models/Userverify.model";
import { PopupRegisterComponent } from "src/app/auth/popup-register/popup-register.component";
import { GuestloginComponent } from "../../../auth/login/Guest_login/guestlogin.component";
import { Merchant } from "src/app/shared/models/merchant";
import { OrderService } from "src/app/shared/services/order.service";
import { CurrencyFormatPipe } from "src/app/shared/layout/pipe/status.pipe";
@Component({
  selector: "app-add-product",
  templateUrl: "./add-product.component.html",
  styleUrls: ["./add-product.component.scss"],
  standalone: true,
  imports: [
    NgStyle,
    NgClass,
    OpenAboutBasketComponent_1,
    NgSelectModule,
    FormsModule,
    NgImageSliderModule,
    AsyncPipe,
    DecimalPipe,
    CurrencyFormatPipe,
    ExtraproductComponent,
    MessagePopupComponent,
    PopupLoginComponent,
    PopupRegisterComponent,
    GuestloginComponent,
  ],
})
export class AddProductComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild("mixmatchSelection", { static: false }) private mixmatchSelection;
  // @ViewChild("selectedProduct", { static: false }) private ProductSelection;
  // @ViewChild(OpenAboutBasketComponent) OpenMessage: OpenAboutBasketComponent;
  @ViewChild("selectedProduct") selectedProductTemplate: TemplateRef<any>;
  @ViewChild(MessagePopupComponent) OpenMessage: MessagePopupComponent; // Reference to the MessagePopupComponent

  @ViewChild("scrollDiv") scrollDiv!: ElementRef;

  @Output() UpdateProductInfo = new EventEmitter<Product>();

  @Input() isProductVisible: boolean;
  @Input() selectedProductId: number;
  @Input() tempBool: boolean;
  @Input() isInfoPopup: boolean;

  pageModel: ProductPagemodel;
  pageModelTemp: ProductPagemodel;
  Merchant$ = this.coreService.Merchant$;
  basket$ = this.coreService.basket$;
  currentBasket: Basket;
  currentBasketItems: BasketItem[] = [];
  products: ProductList[];
  product: Product;
  tempProductId: number;
  ProductQtyId: string;
  is_login_registration_allowed;
  textMessage = ""; // Variable to hold the message to be displayed
  ImageColor = this.coreService.ImageColor$;
  Products$ = this._store.pipe(select(selectProductList));
  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;
  mixandmatchlist: mix_match_response[] = [];
  Subscriptions: Subscription[] = [];
  NewProductVisible = false;
  ExtraProductVisible = false;

  showLogin = false;

  stockLimitText;
  stockLimitNoteText;

  currentUser: User;

  GuestLogin: Boolean = false;
  registerPopup: Boolean = false;

  currentMerchant: Merchant;

  ShowLoginOption: Boolean = false;

  isImageUploading: boolean = false;

  constructor(
    private modalService: NgbModal,
    private _store: Store<IAppState>,
    private route: ActivatedRoute,
    private coreService: CoreService,
    private orderService: OrderService,
    private confirmationDialogService: ConfirmationDialogService,
    private router: Router,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }
  ngOnDestroy(): void {
    if (this.Subscriptions)
      this.Subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  allowGuestCheckout: boolean = true; // Enable or disable guest checkout.

  redirectToLogin() {
    // Logic to redirect to login.
    // this.pageModel.loginModal.style.display = "block";
    this.showLogin = true;
    this.pageModel.loginOptions.style.display = "none";

    console.log("Redirecting to login...");
  }

  closeLogin() {
    // this.pageModel.loginModal.style.display = "none";
    this.showLogin = false;
  }

  closeRegistration() {
    this.registerPopup = false;
    this.pageModel.regModal.style.display = "none";
  }

  redirectToCreateAccount() {
    // Logic to redirect to account creation.
    this.registerPopup = true;
    this.pageModel.regModal.style.display = "block";
    this.pageModel.loginOptions.style.display = "none";
    console.log("Redirecting to create account...");
  }

  cancelClicked() {
    this.pageModel.loginOptions.style.display = "none";
  }

  infoPopupClose() {
    this.pageModel.productModal.style.display = "none";
  }

  productCancelClicked() {
    this.pageModel.productModal.style.display = "none";
  }

  // Method to set GuestLogin value based on the user input
  Guestlogin(value: boolean) {
    this.GuestLogin = value;
  }

  proceedAsGuest() {
    this.GuestLogin = true;
    this.pageModel.loginOptions.style.display = "none";
    // Logic to handle guest checkout.
    console.log("Proceeding as guest...");
  }

  ngOnChanges(changes) {
    if (this.isProductVisible) {
      setTimeout(() => {
        this.OpenVerticallyCentered(
          this.selectedProductTemplate,
          this.selectedProductId,
        );
      }, 200);

      const divElement = this.scrollDiv.nativeElement;

      // Initially ensure the div is at the top
      divElement.scrollTo({ top: 0, behavior: "auto" });

      // Scroll to the bottom of the div
      setTimeout(() => {
        divElement.scrollTo({
          top: divElement.scrollHeight,
          behavior: "smooth",
        });

        // Scroll back to the top after 2 seconds
        setTimeout(() => {
          divElement.scrollTo({ top: 0, behavior: "smooth" });
        }, 1000);
      }, 2000); // Delay for initial scroll
    }
  }

  ngOnInit() {
    this.pageModel = new ProductPagemodel();
    this.pageModelTemp = new ProductPagemodel();

    this.Subscriptions.push(
      this.Merchant$.subscribe((data) => {
        this.currentMerchant = data;
        if (data.webapp_settings) {
          //viewOnly flag used to prevent ordering funtionality

          if (CoreService.MultiOutlet) {
            if (data.webapp_settings?.is_non_clickable_product_multi_outlet) {
              this.pageModel.viewOnly =
                data.webapp_settings?.is_non_clickable_product_multi_outlet;
            }
          } else {
            this.pageModel.viewOnly =
              data.webapp_settings?.is_non_clickable_product;
            this.pageModel.viewOnly =
              data.webapp_settings?.is_non_clickable_product_outlet;
          }

          this.is_login_registration_allowed =
            data?.webapp_settings?.is_login_registration_allowed;
        }
      }),
    );
    this.Subscriptions.push(
      this.basket$.subscribe((data) => {
        this.currentBasket = data;
      }),
    );
    this.Subscriptions.push(
      this.Products$.subscribe((data) => {
        if (data) {
          this.products = data;
        }
      }),
    );
    //we are storing user selected Mix&Match in this session object we need this object in basket also that's why we are storing in session
    if (sessionStorage.getItem("selectedMixAndMatch")) {
      this.pageModel.selectedMixAndMatch = JSON.parse(
        sessionStorage.getItem("selectedMixAndMatch"),
      );
    }
    //we are storing displayed MixAndMatch List in this object once we will display to user then we didn't repeat this again.
    if (sessionStorage.getItem("displayedMixAndMatchList")) {
      this.pageModel.displayedMixAndMatchList = JSON.parse(
        sessionStorage.getItem("displayedMixAndMatchList"),
      );
    }
    //extraProductModal used to selection of extras item if any Productured from the beckend for example if you buy pazza then you can add extra cheese as extra product
    this.NewProductVisible = true;

    this.pageModel.extraProductModal =
      document.getElementById("extraProductModal");

    this.pageModel.stockLimitModal = document.getElementById("stockLimitModal");
    this.pageModel.loginModal = document.getElementById("loginModal");
    this.pageModel.loginOptions = document.getElementById("loginOptions");
    this.pageModel.productInstructionModal = document.getElementById(
      "additionalInformationModal",
    );
    this.pageModel.regModal = document.getElementById("registerModal");
    this.pageModel.productModal = document.getElementById("selectedProduct");
  }

  //funtion used to get selected product from the list
  //funtion used to show selected product
  OpenVerticallyCentered(content, Id) {
    // this.modalService.open(loginData, {
    //   centered: true,
    //   scrollable: true,
    //   backdrop: "static",
    // });

    this._store.dispatch(new GetSingleProduct(Id));
    new Promise((resolve) =>
      this._store.pipe(select(selectProduct)).subscribe((data) => {
        this.product = data;
        if (this.product) {
          this.product = Object.assign([], this.product);
          this.product.catId = this.route.snapshot.params.id;
          resolve(Object.assign([], this.product));
        } else {
          this.pageModel.selectedProduct = Object.assign([], data);
        }
      }),
    ).then((response: Product) => {
      setTimeout(() => {
        this.OpenSelectedProduct(response);
      }, 500);

      setTimeout(() => {
        this.pageModel.productModal.style.display = "block";
      }, 200);
    });

    // this.pageModel.extraProductModal =
    //   document.getElementById("extraProductModal");
  }
  //Pass prodcut data into Pagemodel to show image popup in the screen
  OpenSelectedProduct(response) {
    this.pageModel.selectedProduct = response;

    if (response.images.length > 0)
      this.pageModel.Imageslider = this.getImages(response.images);
    //this two varibale used for binding list of variants for a selected product.
    this.pageModel.selectedProduct.product_image =
      this.pageModel.selectedProduct?.images[0]?.url;
    this.pageModel.firstVariantOptions = [];
    this.pageModel.secondVariantOptions = [];
    //selecting product from the list
    //this.pageModel.selectedProduct = this.products.filter(x => x.id == Id).length > 0 ? this.products.filter(x => x.id == Id)[0] : null;
    this.pageModel.selectedProduct.quantity = 1;
    //check selected product has variant?
    if (this.pageModel.selectedProduct.attribute_details.length > 0) {
      //first Variant dropdown bind
      this.pageModel.firstVariantName =
        this.pageModel.selectedProduct.attribute_details[0].variant[0].attribute_name;
      this.pageModel.selectedProduct.attributes[
        this.pageModel.selectedProduct.attribute_details[0].variant[0]
          .attribute_name
      ].forEach((pattr) => {
        this.pageModel.firstVariantOptions.push(pattr);
      });
      //second Variant dropdown bind
      this.pageModel.secondVariantName =
        this.pageModel.selectedProduct.attribute_details[0].variant[1].attribute_name;
      this.pageModel.selectedProduct.attributes[
        this.pageModel.selectedProduct.attribute_details[0].variant[1]
          .attribute_name
      ].forEach((pattr) => {
        this.pageModel.secondVariantOptions.push(pattr);
      });
      //if product has only one variant then it will defualt selecting by below condition (Logic added by client suggestion)
      if (
        this.pageModel.firstVariantOptions.length < 2 &&
        this.pageModel.secondVariantOptions.length < 2
      ) {
        this.pageModel.firstSelectedVariant =
          this.pageModel.firstVariantOptions[0];
        this.GetValue(1);
        this.pageModel.secondSelectedVariant =
          this.pageModel.secondVariantOptions[0];
        this.GetValue(2);
      } else {
        //patch work as per client suggestion
        this.pageModel.hideSecondattr = this.pageModel.selectedProduct
          .attribute_details[0].is_hide_second_attribute
          ? false
          : true;
        this.pageModel.firstSelectedVariant = null;
        this.pageModel.secondSelectedVariant = null;
      }
    }
    //reset selected varinat if any in previues selected product
    else if (this.pageModel.selectedVariant > 0) {
      this.pageModel.selectedVariant = 0;
    }
  }

  ValidateLogin(pId: number, loginModel) {
    if (this.is_login_registration_allowed) {
      if (this.coreService?.UserSub?.value?.firstName == "temp_user") {
        this.modalService.open(loginModel, {
          centered: true,
          scrollable: true,
          backdrop: "static",
        });
      } else {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (!this.currentUser) {
          this.pageModel.loginOptions.style.display = "block";
        } else {
          if (
            this.pageModel?.selectedProduct?.is_special_instruction == 1 ||
            this.pageModel?.selectedProduct?.is_image_upload_instruction == 1
          ) {
            this.pageModel.productText = "";
            this.pageModel.productImage = "";
            this.pageModel.productInstructionModal.style.display = "block";
          } else {
            this.pageModel.productText = "";
            this.pageModel.productImage = "";
            this.AddProductToBasket(pId, loginModel);
          }
        }
      }
    } else {
      if (
        this.pageModel?.selectedProduct?.is_special_instruction == 1 ||
        this.pageModel?.selectedProduct?.is_image_upload_instruction == 1
      ) {
        this.pageModel.productText = "";
        this.pageModel.productImage = "";
        this.pageModel.productInstructionModal.style.display = "block";
      } else {
        this.pageModel.productText = "";
        this.pageModel.productImage = "";
        this.AddProductToBasket(pId, loginModel);
      }
    }
  }

  //funtion used to Add product to the basket
  AddProductToBasket(pId: number, loginModel) {
    // Check if image upload is compulsory and no image is provided
    if (
      this.pageModel?.selectedProduct?.is_image_upload_instruction == 1 &&
      !this.pageModel.productImageFile
    ) {
      this.OpenMessage.Openpopup(
        "Please upload an image to proceed with this product.",
      );
      return;
    }

    // Upload image if exists before adding to basket
    if (this.pageModel.productImageFile) {
      this.isImageUploading = true;
      this.coreService.hideShowLoader(true);
      this.orderService
        .uploadInstructionImage(this.pageModel.productImageFile)
        .subscribe({
          next: (response) => {
            this.pageModel.productImagePath = response.path;
            this.pageModel.productImageUrl = response.url;
            this.pageModel.productImageFile = null;
            this.isImageUploading = false;
            this.coreService.hideShowLoader(false);
            this.proceedToAddToBasket(pId, loginModel);
          },
          error: (error) => {
            this.isImageUploading = false;
            this.coreService.hideShowLoader(false);
            this.OpenMessage.Openpopup(
              "Failed to upload image. Please try again.",
            );
  //             this.OpenMessage.Openpopup(
  //   `Failed to upload image. ${error?.message || JSON.stringify(error)}`
  // );
            console.error("Image upload error:", error);
          },
        });
    } else {
      this.coreService.hideShowLoader(false);
      this.proceedToAddToBasket(pId, loginModel);
    }
  }

  proceedToAddToBasket(pId: number, loginModel) {
    this.pageModel.productInstructionModal.style.display = "none";

    var data = this.pageModel.productText;
    if (this.is_login_registration_allowed) {
      if (this.coreService?.UserSub?.value?.firstName == "temp_user") {
        this.modalService.open(loginModel, {
          centered: true,
          scrollable: true,
          backdrop: "static",
        });
      } else {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (!this.currentUser) {
          this.pageModel.loginOptions.style.display = "block";
        } else {
          this.pageModel.productModal.style.display = "none";
          let b: Basket;
          let bi: BasketItem;
          let Qty: number;
          let basketitem: any;
          if (this.currentBasket != null) {
            this.currentBasketItems = [...this.currentBasket.items];
          }

          if (
            this.pageModel?.firstVariantOptions &&
            this.pageModel?.firstVariantOptions?.length > 0 &&
            this.pageModel.firstSelectedVariant == undefined
          ) {
            // this.textMessage =
            //   "Unfortunately the item you have selected is out-of-stock currently, please check back later or select an alternative product - our apologies for the inconvenience caused.";
            this.OpenMessage.Openpopup("Please select any variant to proceed.");
            return;
          } else if (
            !this.pageModel?.hideSecondattr &&
            this.pageModel?.secondVariantOptions &&
            this.pageModel?.secondVariantOptions?.length > 0 &&
            this.pageModel.secondSelectedVariant == undefined
          ) {
            this.OpenMessage.Openpopup("Please select any variant to proceed.");
            return;
          }
          //else {

          if (
            this.pageModel.firstSelectedVariant != undefined &&
            this.pageModel.secondSelectedVariant != undefined
          ) {
            //check for variant
            this.pageModel.selectedVariantName =
              " " +
              this.pageModel.firstSelectedVariant +
              " | " +
              this.pageModel.secondSelectedVariant;
          }
          //checking that selected product exsist in the basket for checking product and variant stock
          if (this.currentBasketItems.find((x) => x.qtyId == pId.toString())) {
            //checking that  selected product has variant
            if (this.pageModel.selectedVariant > 0) {
              //checking that  selected product with same variant has in basket?
              basketitem = this.currentBasketItems.find(
                (x) =>
                  x.qtyId == pId.toString() &&
                  x.selectedVariantid == this.pageModel.selectedVariant,
              );
            }
            // else if (this.pageModel.selectedProduct.is_special_instruction) {
            //   basketitem = this.currentBasketItems.find(
            //     (x) =>
            //       x.qtyId == pId.toString() &&
            //       x.special_instruction == this.pageModel.productText
            //   );
            // }
            else {
              //checking that selected product has in basket.
              basketitem = this.currentBasketItems.find(
                (x) => x.qtyId == pId.toString(),
              );
            }
            //checking that any basket item we got from the above step and that basket item have any varinat.
            if (
              basketitem != undefined &&
              basketitem.selectedVariantid == this.pageModel.selectedVariant
            ) {
              Qty =
                basketitem.quantity + this.pageModel.selectedProduct.quantity;
              //checking that selected product has enough if not then prompt
              if (
                (basketitem.stockunlimited == 0 ||
                  basketitem.stockunlimited == 2) &&
                basketitem.stock < Qty
              ) {
                if (basketitem.stock == 0) {
                  this.Open(
                    "Unfortunately the item you have selected is out-of-stock currently, please check back later or select an alternative product - our apologies for the inconvenience caused.",
                  );
                  return;
                } else if (basketitem.stock > 0) {
                  this.stockLimitText = `
                    Product [${basketitem.name}] is low on stock, with only 
                    [${basketitem.stock}] pieces available. 
                    Select ADJUST to change the order quantity to 
                    [${basketitem.stock}] pieces, or CANCEL
                    to remove the product from the order.
              `;
                  this.stockLimitNoteText = `(Note - the system does not reserve stock whilst orders are being created; at checkout stock may 
                    have reduced further - it is recommended to proceed with checkout as soon as possible)`;

                  this.pageModel.stockLimitModal.style.display = "block";
                  return;
                }
              }
            }
            //checking that selected product has enough if not then prompt
            else {
              Qty = this.pageModel.selectedProduct.quantity;
              //checking that selected product has variant
              if (this.pageModel.selectedVariant > 0) {
                //checking that  selected variant has in varinat list
                let item =
                  this.pageModel.selectedProduct.attribute_details.find(
                    (x) => x.id == this.pageModel.selectedVariant,
                  );
                if (item) {
                  this.pageModel.selectedProduct.stock = item.stock;
                  this.pageModel.selectedProduct.stock_unlimited =
                    item.stock_unlimited;
                }
              }
              //checking that selected product has enough if not then prompt
              if (
                (basketitem?.stockunlimited == 0 ||
                  basketitem?.stockunlimited == 2) &&
                basketitem?.stock < Qty
              ) {
                if (basketitem.stock == 0) {
                  this.Open(
                    "Unfortunately the item you have selected is out-of-stock currently, please check back later or select an alternative product - our apologies for the inconvenience caused.",
                  );
                  return;
                } else if (basketitem.stock > 0) {
                  this.stockLimitText = `
                    Product [${basketitem.name}] is low on stock, with only 
                    [${basketitem.stock}] pieces available. 
                    Select ADJUST to change the order quantity to 
                    [${basketitem.stock}] pieces, or CANCEL
                    to remove the product from the order.
              `;
                  this.stockLimitNoteText = `(Note - the system does not reserve stock whilst orders are being created; at checkout stock may 
                    have reduced further - it is recommended to proceed with checkout as soon as possible)`;

                  this.pageModel.stockLimitModal.style.display = "block";
                  return;
                }
              }
            }
          }
          //if product not in basket then check for variant stock
          else {
            Qty = this.pageModel.selectedProduct.quantity;
            //checking that  selected product has variant
            if (this.pageModel.selectedVariant > 0) {
              //checking that  selected variant has in varinat list
              let item = this.pageModel.selectedProduct.attribute_details.find(
                (x) => x.id == this.pageModel.selectedVariant,
              );
              if (item) {
                this.pageModel.selectedProduct.stock = item.stock;
                this.pageModel.selectedProduct.stock_unlimited =
                  item.stock_unlimited;
              }
            }
            //checking that selected product has enough if not then prompt
            if (
              (this.pageModel.selectedProduct?.stock_unlimited == 0 ||
                this.pageModel.selectedProduct?.stock_unlimited == 2) &&
              this.pageModel.selectedProduct?.stock < Qty
            ) {
              if (this.pageModel.selectedProduct?.stock == 0) {
                this.Open(
                  "Unfortunately the item you have selected is out-of-stock currently, please check back later or select an alternative product - our apologies for the inconvenience caused.",
                );
                return;
              } else if (this.pageModel.selectedProduct.stock > 0) {
                this.stockLimitText = `
                    Product [${this.pageModel.selectedProduct.name}] is low on stock, with only 
                    [${this.pageModel.selectedProduct.stock}] pieces available. 
                    Select ADJUST to change the order quantity to 
                    [${this.pageModel.selectedProduct.stock}] pieces, or CANCEL
                    to remove the product from the order.
              `;
                this.stockLimitNoteText = `(Note - the system does not reserve stock whilst orders are being created; at checkout stock may 
                    have reduced further - it is recommended to proceed with checkout as soon as possible)`;

                this.pageModel.stockLimitModal.style.display = "block";
                return;
              }
            }
          }
          //find variant id in selected product variant
          if (this.pageModel.selectedVariant > 0) {
            let item = this.pageModel.selectedProduct.attribute_details.find(
              (x) => x.id == this.pageModel.selectedVariant,
            );
            if (item) {
              this.pageModel.selectedProduct.stock = item.stock;
              this.pageModel.selectedProduct.stock_unlimited =
                item.stock_unlimited;
            }
          }

          //create basket object as per product selection
          bi = {
            Id: this.pageModel.selectedProduct.id,
            qtyId: this.pageModel.selectedProduct.id.toString(),
            productcatId: this.pageModel.selectedProduct.catId,
            productId: null,
            name: this.pageModel.selectedProduct.name,
            price: this.pageModel.selectedProduct.is_discount
              ? this.pageModel.selectedProduct.discounted_price
              : this.pageModel.selectedProduct.price,
            is_discount: this.pageModel.selectedProduct.is_discount,
            Actualprice: this.pageModel.selectedProduct.price,
            discountprice: this.pageModel.selectedProduct.is_discount
              ? this.pageModel.selectedProduct.discounted_price
              : 0,
            productImage: this.pageModel.selectedProduct.product_image,
            // productImage: this.pageModel.selectedProduct.images[0]?.url,
            stockunlimited: this.pageModel.selectedProduct.stock_unlimited,
            stock: this.pageModel.selectedProduct.stock,
            extra_product_limit:
              this.pageModel.selectedProduct.extra_product_limit ?? 0,
            quantity: Qty,
            selFirstAttrName: "attr1",
            selSecondAttrName: "attr2",
            selFirstAttrValue: this.pageModel.firstSelectedVariant,
            selSecondAttrValue: this.pageModel.secondSelectedVariant,
            selectedVariantid: this.pageModel.selectedVariant,
            SelectedVariantName: this.pageModel.selectedVariantName,
            totalprice: this.coreService.GetTotalprice(
              this.pageModel.selectedProduct,
            ),
            vat_rate: this.pageModel.selectedProduct.vat_rate,
            vat_amount: this.pageModel.selectedProduct.vat_amount,
            is_delivery_fee_product:
              this.pageModel.selectedProduct.is_delivery_fee_product,
            is_mixandmatch:
              this.pageModel.selectedProduct.is_mix_and_match_eligible,
            is_promo_exclude: this.pageModel.selectedProduct.is_promo_exclude,
            special_instruction: this.pageModel.productText,
            special_instruction_image: this.pageModel.productImagePath,
            special_instruction_image_url: this.pageModel.productImageUrl,
          };
          // display popup for mix&match selection logic
          this.AdditionalLogicOnSelectedProduct(this.pageModel.selectedProduct);

          this.UpdateProductInfo.emit(this.pageModel.selectedProduct);

          //find Open Basket has selected product
          if (this.currentBasketItems.find((x) => x.qtyId == pId.toString())) {
            //checking that selected product has variant
            if (this.pageModel.selectedVariant > 0) {
              //checking that open basket has selected varinat with same product if yes then quantity in same product variant.
              if (
                this.currentBasketItems.find(
                  (x) =>
                    x.qtyId == pId.toString() &&
                    x.selectedVariantid == this.pageModel.selectedVariant,
                )
              ) {
                basketitem = this.currentBasketItems.find(
                  (x) =>
                    x.qtyId == pId.toString() &&
                    x.selectedVariantid == this.pageModel.selectedVariant,
                );
                if (basketitem != undefined)
                  this.currentBasketItems.find(
                    (x) =>
                      x.qtyId == pId.toString() &&
                      x.selectedVariantid == this.pageModel.selectedVariant,
                  ).quantity = Qty;
              }
              //add new
              else this.currentBasketItems.push(bi);
            }
            //checking that open basket has selected product if yes then quantity in same product.
            else if (
              this.currentBasketItems.find((x) => x.qtyId == pId.toString())
            ) {
              basketitem = this.currentBasketItems.find(
                (x) => x.qtyId == pId.toString(),
              );
              if (basketitem != undefined)
                this.currentBasketItems.find(
                  (x) => x.qtyId == pId.toString(),
                ).quantity = Qty;
            }
            //add new
            else {
              this.currentBasketItems.push(bi);
            }
          }
          //add new
          else {
            this.currentBasketItems.push(bi);
          }
          //basket Totals
          this.pageModel.basketTotal = this.currentBasketItems.reduce(
            (sum, item) => sum + item.price * item.quantity,
            0,
          );
          let disbasketTotal = this.currentBasketItems
            .filter((x) => !x.is_promo_exclude)
            .reduce((sum, item) => sum + item.price * item.quantity, 0);

          const avgVat =
            this.currentBasketItems
              .filter((x) => x.price > 0)
              .reduce((sum, item) => sum + item.vat_rate, 0) /
            this.currentBasketItems.filter((x) => x.price > 0).length;
          this.pageModel.basketVATTotal =
            (this.pageModel.basketTotal * avgVat) / 100;
          this.pageModel.basketTotalLessVAT =
            this.pageModel.basketTotal - this.pageModel.basketVATTotal;
          // updating basket as per product selection
          b = {
            ...this.currentBasket,
            items: this.currentBasketItems,
            retailerId: CoreService.retailerId,
            discountableTotal: disbasketTotal,
            orderTotal: this.pageModel.basketTotal,
            orderTotalLessVAT: this.pageModel.basketTotalLessVAT,
            VATAmt: this.pageModel.basketVATTotal,
          };

          this.coreService.addItemToBasket(b);
          //this.modalService.dismissAll();
          // }
        }
      }
    } else {
      this.pageModel.productModal.style.display = "none";
      let b: Basket;
      let bi: BasketItem;
      let Qty: number;
      let basketitem: any;
      if (this.currentBasket != null) {
        this.currentBasketItems = [...this.currentBasket.items];
      }

      if (
        this.pageModel?.firstVariantOptions &&
        this.pageModel?.firstVariantOptions?.length > 0 &&
        this.pageModel.firstSelectedVariant == undefined
      ) {
        // this.textMessage =
        //   "Unfortunately the item you have selected is out-of-stock currently, please check back later or select an alternative product - our apologies for the inconvenience caused.";
        this.OpenMessage.Openpopup("Please select any variant to proceed.");
        return;
      } else if (
        !this.pageModel?.hideSecondattr &&
        this.pageModel?.secondVariantOptions &&
        this.pageModel?.secondVariantOptions?.length > 0 &&
        this.pageModel.secondSelectedVariant == undefined
      ) {
        this.OpenMessage.Openpopup("Please select any variant to proceed.");
        return;
      }

      //check for variant
      if (
        this.pageModel.firstSelectedVariant != undefined &&
        this.pageModel.secondSelectedVariant != undefined
      ) {
        this.pageModel.selectedVariantName =
          " " +
          this.pageModel.firstSelectedVariant +
          " | " +
          this.pageModel.secondSelectedVariant;
      }
      //checking that selected product exsist in the basket for checking product and variant stock
      if (this.currentBasketItems.find((x) => x.qtyId == pId.toString())) {
        //checking that  selected product has variant
        if (this.pageModel.selectedVariant > 0) {
          //checking that  selected product with same variant has in basket?
          basketitem = this.currentBasketItems.find(
            (x) =>
              x.qtyId == pId.toString() &&
              x.selectedVariantid == this.pageModel.selectedVariant,
          );
        } else {
          //checking that selected product has in basket.
          basketitem = this.currentBasketItems.find(
            (x) => x.qtyId == pId.toString(),
          );
        }
        //checking that any basket item we got from the above step and that basket item have any varinat.
        if (
          basketitem != undefined &&
          basketitem.selectedVariantid == this.pageModel.selectedVariant
        ) {
          Qty = basketitem.quantity + this.pageModel.selectedProduct.quantity;
          //checking that selected product has enough if not then prompt
          if (
            (basketitem.stockunlimited == 0 ||
              basketitem.stockunlimited == 2) &&
            basketitem.stock <= Qty
          ) {
            if (basketitem.stock == 0) {
              this.Open(
                "Unfortunately the item you have selected is out-of-stock currently, please check back later or select an alternative product - our apologies for the inconvenience caused.",
              );
              return;
            } else if (basketitem.stock > 0) {
              this.stockLimitText = `
                    Product [${basketitem.name}] is low on stock, with only 
                    [${basketitem.stock}] pieces available. 
                    Select ADJUST to change the order quantity to 
                    [${basketitem.stock}] pieces, or CANCEL
                    to remove the product from the order.
              `;
              this.stockLimitNoteText = `(Note - the system does not reserve stock whilst orders are being created; at checkout stock may 
                    have reduced further - it is recommended to proceed with checkout as soon as possible)`;

              this.pageModel.stockLimitModal.style.display = "block";
              return;
            }
          }
        }
        //checking that selected product has enough if not then prompt
        else {
          Qty = this.pageModel.selectedProduct.quantity;
          //checking that selected product has variant
          if (this.pageModel.selectedVariant > 0) {
            //checking that  selected variant has in varinat list
            let item = this.pageModel.selectedProduct.attribute_details.find(
              (x) => x.id == this.pageModel.selectedVariant,
            );
            if (item) {
              this.pageModel.selectedProduct.stock = item.stock;
              this.pageModel.selectedProduct.stock_unlimited =
                item.stock_unlimited;
            }
          }
          //checking that selected product has enough if not then prompt
          if (
            (basketitem.stockunlimited == 0 ||
              basketitem.stockunlimited == 2) &&
            basketitem.stock <= Qty
          ) {
            if (basketitem.stock == 0) {
              this.Open(
                "Unfortunately the item you have selected is out-of-stock currently, please check back later or select an alternative product - our apologies for the inconvenience caused.",
              );
              return;
            } else if (basketitem.stock > 0) {
              this.pageModel.stockLimitModal.style.display = "block";
              this.stockLimitText = `
                    Product [${basketitem.name}] is low on stock, with only 
                    [${basketitem.stock}] pieces available. 
                    Select ADJUST to change the order quantity to 
                    [${basketitem.stock}] pieces, or CANCEL
                    to remove the product from the order.
              `;
              this.stockLimitNoteText = `(Note - the system does not reserve stock whilst orders are being created; at checkout stock may 
                    have reduced further - it is recommended to proceed with checkout as soon as possible)`;

              this.pageModel.stockLimitModal.style.display = "block";
              return;
            }
          }
        }
      }
      //if product not in basket then check for variant stock
      else {
        Qty = this.pageModel.selectedProduct.quantity;
        //checking that  selected product has variant
        if (this.pageModel.selectedVariant > 0) {
          //checking that  selected variant has in varinat list
          let item = this.pageModel.selectedProduct.attribute_details.find(
            (x) => x.id == this.pageModel.selectedVariant,
          );
          if (item) {
            this.pageModel.selectedProduct.stock = item.stock;
            this.pageModel.selectedProduct.stock_unlimited =
              item.stock_unlimited;
          }
        }
        //checking that selected product has enough if not then prompt
        if (
          !this.pageModel.selectedProduct.stock_unlimited &&
          this.pageModel.selectedProduct.stock <= Qty
        ) {
          this.Open(
            "Unfortunately the item you have selected is out-of-stock currently, please check back later or select an alternative product - our apologies for the inconvenience caused.",
          );
          return;
        }
      }
      //find variant id in selected product variant
      if (this.pageModel.selectedVariant > 0) {
        let item = this.pageModel.selectedProduct.attribute_details.find(
          (x) => x.id == this.pageModel.selectedVariant,
        );
        if (item) {
          this.pageModel.selectedProduct.stock = item.stock;
          this.pageModel.selectedProduct.stock_unlimited = item.stock_unlimited;
        }
      }

      //create basket object as per product selection
      bi = {
        Id: this.pageModel.selectedProduct.id,
        qtyId: this.pageModel.selectedProduct.id.toString(),
        productcatId: this.pageModel.selectedProduct.catId,
        productId: null,
        name: this.pageModel.selectedProduct.name,
        price: this.pageModel.selectedProduct.is_discount
          ? this.pageModel.selectedProduct.discounted_price
          : this.pageModel.selectedProduct.price,
        is_discount: this.pageModel.selectedProduct.is_discount,
        Actualprice: this.pageModel.selectedProduct.price,
        discountprice: this.pageModel.selectedProduct.is_discount
          ? this.pageModel.selectedProduct.discounted_price
          : 0,
        // productImage: this.pageModel.selectedProduct.images[0]?.url,
        productImage: this.pageModel.selectedProduct.product_image,
        stockunlimited: this.pageModel.selectedProduct.stock_unlimited,
        stock: this.pageModel.selectedProduct.stock,
        extra_product_limit:
          this.pageModel.selectedProduct.extra_product_limit ?? 0,
        quantity: Qty,
        selFirstAttrName: "attr1",
        selSecondAttrName: "attr2",
        selFirstAttrValue: this.pageModel.firstSelectedVariant,
        selSecondAttrValue: this.pageModel.secondSelectedVariant,
        selectedVariantid: this.pageModel.selectedVariant,
        SelectedVariantName: this.pageModel.selectedVariantName,
        totalprice: this.coreService.GetTotalprice(
          this.pageModel.selectedProduct,
        ),
        vat_rate: this.pageModel.selectedProduct.vat_rate,
        vat_amount: this.pageModel.selectedProduct.vat_amount,
        is_delivery_fee_product:
          this.pageModel.selectedProduct.is_delivery_fee_product,
        is_mixandmatch:
          this.pageModel.selectedProduct.is_mix_and_match_eligible,
        is_promo_exclude: this.pageModel.selectedProduct.is_promo_exclude,
        special_instruction: this.pageModel.productText,
        special_instruction_image: this.pageModel.productImagePath,
        special_instruction_image_url: this.pageModel.productImageUrl,
      };
      // display popup for mix&match selection logic
      this.AdditionalLogicOnSelectedProduct(this.pageModel.selectedProduct);

      //find Open Basket has selected product
      if (this.currentBasketItems.find((x) => x.qtyId == pId.toString())) {
        //checking that selected product has variant
        if (this.pageModel.selectedVariant > 0) {
          //checking that open basket has selected varinat with same product if yes then quantity in same product variant.
          if (
            this.currentBasketItems.find(
              (x) =>
                x.qtyId == pId.toString() &&
                x.selectedVariantid == this.pageModel.selectedVariant,
            )
          ) {
            basketitem = this.currentBasketItems.find(
              (x) =>
                x.qtyId == pId.toString() &&
                x.selectedVariantid == this.pageModel.selectedVariant,
            );
            if (basketitem != undefined)
              this.currentBasketItems.find(
                (x) =>
                  x.qtyId == pId.toString() &&
                  x.selectedVariantid == this.pageModel.selectedVariant,
              ).quantity = Qty;
          }
          //add new
          else this.currentBasketItems.push(bi);
        }
        //checking that open basket has selected product if yes then quantity in same product.
        else if (
          this.currentBasketItems.find((x) => x.qtyId == pId.toString())
        ) {
          basketitem = this.currentBasketItems.find(
            (x) => x.qtyId == pId.toString(),
          );
          if (basketitem != undefined)
            this.currentBasketItems.find(
              (x) => x.qtyId == pId.toString(),
            ).quantity = Qty;
        }
        //add new
        else {
          this.currentBasketItems.push(bi);
        }
      }
      //add new
      else {
        this.currentBasketItems.push(bi);
      }
      //basket Totals
      this.pageModel.basketTotal = this.currentBasketItems.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0,
      );
      let disbasketTotal = this.currentBasketItems
        .filter((x) => !x.is_promo_exclude)
        .reduce((sum, item) => sum + item.price * item.quantity, 0);

      const avgVat =
        this.currentBasketItems
          .filter((x) => x.price > 0)
          .reduce((sum, item) => sum + item.vat_rate, 0) /
        this.currentBasketItems.filter((x) => x.price > 0).length;
      this.pageModel.basketVATTotal =
        (this.pageModel.basketTotal * avgVat) / 100;
      this.pageModel.basketTotalLessVAT =
        this.pageModel.basketTotal - this.pageModel.basketVATTotal;
      // updating basket as per product selection
      b = {
        ...this.currentBasket,
        items: this.currentBasketItems,
        retailerId: CoreService.retailerId,
        discountableTotal: disbasketTotal,
        orderTotal: this.pageModel.basketTotal,
        orderTotalLessVAT: this.pageModel.basketTotalLessVAT,
        VATAmt: this.pageModel.basketVATTotal,
      };

      this.coreService.addItemToBasket(b);
      // this.modalService.dismissAll();
    }
  }

  closeStockLimit() {
    // this.deleteCartItem(
    //   this.currentBasketItem?.Id,
    //   this.currentBasketItem?.selectedVariantid,
    //   this.currentBasketItem?.qtyId
    // );

    this.modalService.dismissAll();
    this.pageModel.stockLimitModal.style.display = "none";
  }

  adjustStockLimit() {
    // this.deleteCartItem(
    //   this.currentBasketItem?.Id,
    //   this.currentBasketItem?.selectedVariantid,
    //   this.currentBasketItem?.qtyId
    // );
    this.UpdateProductQuantity(3);

    this.pageModel.stockLimitModal.style.display = "none";
  }

  //funtion used to update product Quantity to the basket
  UpdateProductQuantity(op: number) {
    switch (op) {
      //Increase product quantity by 1
      case 1:
        if (this.pageModel.selectedProduct.quantity > 1) {
          this.pageModel.selectedProduct.quantity =
            this.pageModel.selectedProduct.quantity - 1;
        }
        break;
      //Decrease product quantity by 1
      case 2:
        {
          if (this.pageModel.selectedVariant > 0) {
            let item = this.pageModel.selectedProduct.attribute_details.find(
              (x) => x.id == this.pageModel.selectedVariant,
            );
            if (item) {
              this.pageModel.selectedProduct.stock = item.stock;
              this.pageModel.selectedProduct.stock_unlimited =
                item.stock_unlimited;
            }
          }
          if (
            (this.pageModel.selectedProduct.stock_unlimited == 0 ||
              this.pageModel.selectedProduct.stock_unlimited == 2) &&
            this.pageModel.selectedProduct.stock <=
              this.pageModel.selectedProduct.quantity
          ) {
            if (this.pageModel.selectedProduct.stock == 0) {
              this.Open(
                "Unfortunately the item you have selected is out-of-stock currently, please check back later or select an alternative product - our apologies for the inconvenience caused.",
              );
              return;
            } else if (this.pageModel.selectedProduct.stock > 0) {
              this.stockLimitText = `
                    Product [${this.pageModel.selectedProduct.name}] is low on stock, with only 
                    [${this.pageModel.selectedProduct.stock}] pieces available. 
                    Select ADJUST to change the order quantity to 
                    [${this.pageModel.selectedProduct.stock}] pieces, or CANCEL
                    to remove the product from the order.
              `;
              this.stockLimitNoteText = `(Note - the system does not reserve stock whilst orders are being created; at checkout stock may 
                    have reduced further - it is recommended to proceed with checkout as soon as possible)`;

              this.pageModel.stockLimitModal.style.display = "block";
              return;
            }
          }

          this.pageModel.selectedProduct.quantity =
            this.pageModel.selectedProduct.quantity + 1;
        }
        break;
      case 3:
        {
          if (this.pageModel.selectedVariant > 0) {
            let item = this.pageModel.selectedProduct.attribute_details.find(
              (x) => x.id == this.pageModel.selectedVariant,
            );
            if (item) {
              this.pageModel.selectedProduct.stock = item.stock;
              this.pageModel.selectedProduct.stock_unlimited =
                item.stock_unlimited;
            }
          }
          if (
            (this.pageModel.selectedProduct.stock_unlimited == 0 ||
              this.pageModel.selectedProduct.stock_unlimited == 2) &&
            this.pageModel.selectedProduct.stock <=
              this.pageModel.selectedProduct.quantity
          ) {
            if (this.pageModel.selectedProduct.stock == 0) {
              this.Open(
                "Unfortunately the item you have selected is out-of-stock currently, please check back later or select an alternative product - our apologies for the inconvenience caused.",
              );
              return;
            } else if (this.pageModel.selectedProduct.stock > 0) {
              this.pageModel.selectedProduct.quantity =
                this.pageModel.selectedProduct.stock;
              return;
            }
          }
        }
        break;
    }
  }
  //funtion used to Get product variant value
  GetValue(fromPicker) {
    //with this conditon we are binding second attribute based on first variant selection

    if (fromPicker == 1) {
      this.pageModel.secondVariantOptions = [];
      this.pageModel.secondSelectedVariant = undefined;
      if (this.pageModel.firstSelectedVariant != undefined) {
        //binding second varinat dropdown based on first
        this.pageModel.selectedProduct.attribute_details.forEach((pattr) => {
          if (pattr.variant[0].value == this.pageModel.firstSelectedVariant) {
            this.pageModel.secondVariantOptions.push(pattr.variant[1].value);
          }
        });
      }
      if (this.pageModel.secondSelectedVariant == undefined) {
        this.pageModel.secondSelectedVariant =
          this.pageModel.secondVariantOptions[0];
      }
    }
    //checking that both variant has selected
    if (
      this.pageModel.firstSelectedVariant != undefined &&
      this.pageModel.secondSelectedVariant != undefined
    ) {
      let variant1;
      let variant2;
      //this flag is used to skip loop if both variant is matched
      //FYI we have depand on text instead of ids that's why we are comparing variants name insetad of IDs
      let keepGoing = true;
      this.pageModel.selectedProduct.attribute_details.forEach((pattr) => {
        if (keepGoing) {
          this.pageModel.matchFound1 = false;
          this.pageModel.matchFound2 = false;
          if (pattr.variant[0].value == this.pageModel.firstSelectedVariant) {
            variant1 = pattr.variant[0].value;
          } else {
            variant2 = pattr.variant[1].value;
          }
          if (pattr.variant[1].value == this.pageModel.secondSelectedVariant) {
            variant2 = pattr.variant[1].value;
          } else {
            variant1 = pattr.variant[1].value;
          }
          if (variant1 == this.pageModel.firstSelectedVariant) {
            this.pageModel.matchFound1 = true;
          }
          if (this.pageModel.matchFound1) {
            if (variant2 == this.pageModel.secondSelectedVariant) {
              this.pageModel.matchFound2 = true;
            }
          }
          if (this.pageModel.matchFound1 && this.pageModel.matchFound2) {
            this.pageModel.selectedProduct.price = Number(pattr.price);
            this.pageModel.selectedProduct.product_image =
              pattr.image ?? this.pageModel.selectedProduct?.images[0]?.url;

            this.pageModel.hideSecondattr = !pattr.is_hide_second_attribute;
            if (Number(pattr.discounted_price) > 0) {
              this.pageModel.selectedProduct.discounted_price = Number(
                pattr.discounted_price,
              );
            }
            this.pageModel.selectedProduct.price = Number(pattr.price);
            this.pageModel.selectedVariant = pattr.id;
            keepGoing = false;
          }
        }
      });
    }
  }

  //funtion used to show error message in designed popup
  Open(Message: string) {
    this.modalService.dismissAll();
    this.OpenMessage.Openpopup(Message);
  }
  //funtion used to close popup
  closemixMatch() {
    this.modalService.dismissAll();
    if (this.pageModel.selectedProduct.extra_product_category_id > 0) {
      this.ExtraProductVisible = true;
      this.tempProductId = this.pageModel.selectedProduct.id;
      let qty =
        this.currentBasketItems.filter(
          (x) => x.Id == this.pageModel.selectedProduct.id,
        ).length + 1;
      this.ProductQtyId = this.pageModel.selectedProduct.id + "_" + qty;

      this.pageModel.extraProductModal.style.display = "block";
    } else if (
      this.pageModel.selectedProduct.second_sale_suggest &&
      this.pageModel.selectedProduct.second_sale_suggest.length > 0
    ) {
      //as per the client suggestion we are using single of list may be in future we have to changes this 07/02/2023
      let objsecondsale = this.pageModel.selectedProduct.second_sale_suggest[0];
      this.confirmationDialogService
        .confirm(
          objsecondsale.sale_suggest_text,
          objsecondsale.sale_suggest_description,
        )
        .then((confirmed) => {
          if (confirmed) {
            if (this.pageModel.selectedProduct.upsell_category_id != null)
              this.NavigateTo(
                this.pageModel.selectedProduct.upsell_category_id,
              );
            // this.OpenVerticallyCentered(this.ProductSelection, objsecondsale.id);
          }
        })
        .catch(() => {
          console.log(
            "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)",
          );
        });
    }
  }

  NavigateTo(category: number) {
    this.coreService.navigateTo("/products/" + category);
  }

  closeExtra() {
    this.pageModel.extraProductModal.style.display = "none";
    if (
      this.pageModel?.selectedProduct?.second_sale_suggest &&
      this.pageModel.selectedProduct.second_sale_suggest.length > 0
    ) {
      //as per the client suggestion we are using single of list may be in future we have to changes this 07/02/2023
      let objsecondsale = this.pageModel.selectedProduct.second_sale_suggest[0];
      this.confirmationDialogService
        .confirm(
          objsecondsale.sale_suggest_text,
          objsecondsale.sale_suggest_description,
        )
        .then((confirmed) => {
          if (confirmed) {
            if (this.pageModel.selectedProduct.upsell_category_id != null)
              this.NavigateTo(
                this.pageModel.selectedProduct.upsell_category_id,
              );
            // this.OpenVerticallyCentered(this.ProductSelection, objsecondsale.id);
          }
        })
        .catch(() => {
          console.log(
            "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)",
          );
        });
    }
  }
  //funtion implemented to match user selection mix&match schema logic
  AdditionalLogicOnSelectedProduct(product) {
    this.modalService.dismissAll();
    //checking that product has mix&match?
    if (product.is_mix_and_match_eligible) {
      //isvalid used to show mix&match selection model popup
      let isvalid = false;
      //isproductAdded used to exclude those mix&match item who is alredy in the list
      let isproductAdded = false;
      //mixandmatchlist used to show the availble mix&match in selected product
      this.mixandmatchlist = [];
      if (this.pageModel.selectedVariant > 0)
        product.mix_and_match_id =
          this.pageModel.selectedProduct.attribute_details.find(
            (x) => x.id == this.pageModel.selectedVariant,
          ).mix_and_match_id;
      product.mix_and_match_id.forEach((ccElement) => {
        if (!this.pageModel.selectedMixAndMatch)
          this.pageModel.selectedMixAndMatch = [];
        //displayedMixAndMatchList used to maintain the viewed mix&match list selection.
        //checking that user has saw this mix&match schema
        if (
          !(
            this.pageModel.displayedMixAndMatchList.filter(
              (x) => x.id == ccElement.id,
            ).length > 0
          )
        ) {
          this.pageModel.displayedMixAndMatchList.push(ccElement);
          sessionStorage.setItem(
            "displayedMixAndMatchList",
            JSON.stringify(this.pageModel.displayedMixAndMatchList),
          );
          this.mixandmatchlist.push(ccElement);
          isvalid = true;
        }
        //checking that selected product present in schema and item remain to fill the eligibility
        else if (
          this.pageModel.selectedMixAndMatch.filter((x) => x.id == ccElement.id)
            .length > 0 &&
          this.pageModel.selectedMixAndMatch.filter((x) => x.quantity > 0)
            .length > 0
        ) {
          //retrieve selected product from the selected schema
          let selectedproduct = this.pageModel.selectedMixAndMatch.find(
            (x) => x.id == ccElement.id && x.quantity > 0,
          );
          if (selectedproduct && !isproductAdded) {
            //checking that selected product has variant if product find with same variant quantity will add in same product else push new product
            if (this.pageModel.selectedVariant > 0) {
              if (
                selectedproduct.product_ids.filter(
                  (x) =>
                    x.id == this.pageModel.selectedProduct.id &&
                    x.variant_id == this.pageModel.selectedVariant,
                ).length > 0
              )
                selectedproduct.product_ids.find(
                  (x) =>
                    x.id == this.pageModel.selectedProduct.id &&
                    x.variant_id == this.pageModel.selectedVariant,
                ).quantity += this.pageModel.selectedProduct.quantity;
              else
                selectedproduct.product_ids.push({
                  id: this.pageModel.selectedProduct.id,
                  quantity: this.pageModel.selectedProduct.quantity,
                  variant_id: this.pageModel.selectedVariant,
                  price:
                    this.pageModel.selectedProduct.discounted_price > 0
                      ? this.pageModel.selectedProduct.discounted_price
                      : this.pageModel.selectedProduct.price,
                });
            } else if (
              selectedproduct.product_ids.filter(
                (x) => x.id == this.pageModel.selectedProduct.id,
              ).length > 0
            )
              selectedproduct.product_ids.find(
                (x) => x.id == this.pageModel.selectedProduct.id,
              ).quantity += this.pageModel.selectedProduct.quantity;
            else
              selectedproduct.product_ids.push({
                id: this.pageModel.selectedProduct.id,
                quantity: this.pageModel.selectedProduct.quantity,
                variant_id: this.pageModel.selectedVariant,
                price:
                  this.pageModel.selectedProduct.discounted_price > 0
                    ? this.pageModel.selectedProduct.discounted_price
                    : this.pageModel.selectedProduct.price,
              });
            selectedproduct.quantity -= this.pageModel.selectedProduct.quantity;
            isproductAdded = true;
            sessionStorage.setItem(
              "selectedMixAndMatch",
              JSON.stringify(this.pageModel.selectedMixAndMatch),
            );
          }
        } else {
          //user selection list for mix&match schema
          this.mixandmatchlist.push(ccElement);
          isvalid = true;
        }
      });
      if (isvalid && !isproductAdded)
        this.modalService.open(this.mixmatchSelection, {
          centered: true,
          scrollable: true,
          backdrop: "static",
        });
    }

    // checking that item in extra in category?
    else if (this.pageModel.selectedProduct.extra_product_category_id > 0) {
      this.ExtraProductVisible = true;
      this.tempProductId = this.pageModel.selectedProduct.id;
      let qty =
        this.currentBasketItems.filter(
          (x) => x.Id == this.pageModel.selectedProduct.id,
        ).length + 1;
      this.ProductQtyId = this.pageModel.selectedProduct.id + "_" + qty;
      this.NewProductVisible = true;
      this.pageModel.extraProductModal.style.display = "block";
    }
    //checking that product has second_sale_suggest?
    //second sale suggestion used to add suggested product to user
    else if (
      product.second_sale_suggest &&
      product.second_sale_suggest.length > 0
    ) {
      //as per the client suggestion we are using single of list may be in future we have to changes this 07/02/2023
      let objsecondsale = product.second_sale_suggest[0];
      this.confirmationDialogService
        .confirm(
          objsecondsale.sale_suggest_text,
          objsecondsale.sale_suggest_description,
        )
        .then((confirmed) => {
          if (confirmed) {
            if (this.pageModel.selectedProduct.upsell_category_id != null)
              this.NavigateTo(
                this.pageModel.selectedProduct.upsell_category_id,
              );

            // this.OpenVerticallyCentered(this.ProductSelection, objsecondsale.id);
          }
        })
        .catch(() => {
          console.log(
            "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)",
          );
        });
    }
  }
  //funtion used to store user selected mix&match schema
  AddMixAndMatch(resp1: mix_match_response) {
    this.modalService.dismissAll(this.mixmatchSelection);
    //checking that passed object is mix&match object or error
    if (resp1 && resp1.id > 0) {
      if (!this.pageModel.selectedMixAndMatch)
        this.pageModel.selectedMixAndMatch = [];
      let item = {
        id: this.pageModel.selectedProduct.id,
        quantity: this.pageModel.selectedProduct.quantity,
        variant_id: this.pageModel.selectedVariant,
        price:
          this.pageModel.selectedProduct.discounted_price > 0
            ? this.pageModel.selectedProduct.discounted_price
            : this.pageModel.selectedProduct.price,
      };
      let resp = { ...resp1, product_ids: [] };
      resp.product_ids = [];
      //linking mix&match to the specific product by adding product id in selected mix&match.
      resp.product_ids.push(item);
      resp.quantity = resp.quantity - this.pageModel.selectedProduct.quantity;
      //adding mix&match to the selected mix&match schema
      this.pageModel.selectedMixAndMatch.push(resp);
      sessionStorage.setItem(
        "selectedMixAndMatch",
        JSON.stringify(this.pageModel.selectedMixAndMatch),
      );
    }
    if (this.pageModel.selectedProduct.extra_product_category_id > 0) {
      this.ExtraProductVisible = true;
      this.tempProductId = this.pageModel.selectedProduct.id;
      let qty = this.currentBasketItems.filter(
        (x) => x.Id == this.pageModel.selectedProduct.id,
      ).length;
      this.ProductQtyId = this.pageModel.selectedProduct.id + "_" + qty;
      this.pageModel.extraProductModal.style.display = "block";
    } else if (
      this.pageModel.selectedProduct.second_sale_suggest &&
      this.pageModel.selectedProduct.second_sale_suggest.length > 0
    ) {
      //as per the client suggestion we are using single of list may be in future we have to changes this 07/02/2023
      let objsecondsale = this.pageModel.selectedProduct.second_sale_suggest[0];
      this.confirmationDialogService
        .confirm(
          objsecondsale.sale_suggest_text,
          objsecondsale.sale_suggest_description,
        )
        .then((confirmed) => {
          if (confirmed) {
            if (this.pageModel.selectedProduct.upsell_category_id != null)
              this.NavigateTo(
                this.pageModel.selectedProduct.upsell_category_id,
              );
            // this.OpenVerticallyCentered(this.ProductSelection, objsecondsale.id);
          }
        })
        .catch(() => {
          console.log(
            "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)",
          );
        });
    }
  }
  //
  getImages(obj: any[]) {
    return obj.map((images) => {
      return {
        image: images.url,
        thumbImage: images.url,
        alt: "alt of image",
      };
    });
  }

  RedirectToLogin() {
    // Method to handle user logout

    // Remove user data from local storage
    localStorage.removeItem("currentUser");

    // Notify subscribers that user data has been cleared
    this.coreService.UserSub.next(null);
    this.modalService.dismissAll();
    // Clear the shopping basket
    // this.coreService.clearBasket();

    // Navigate to the Login page
    // this.coreService.navigateTo("/login");
    this.coreService.navigateTo("/dashboard");
  }

  closeAdditionalInfo() {
    this.pageModel.productInstructionModal.style.display = "none";
    this.pageModel.productText = "";
    this.pageModel.productImage = "";
    this.pageModel.productImageFile = null;
    this.pageModel.productImagePath = "";
    this.pageModel.productImageUrl = "";
  }

  // onImageUpload(event: any) {
  //   const file = event.target.files[0];
  //   if (file) {
  //     // Validate file size (2MB = 2 * 1024 * 1024 bytes)
  //     const maxSize = 2 * 1024 * 1024;
  //     if (file.size > maxSize) {
  //       this.OpenMessage.Openpopup("Image size must be less than 2MB.");
  //       event.target.value = "";
  //       return;
  //     }

  //     // Validate file type
  //     const allowedTypes = [
  //       "image/jpeg",
  //       "image/png",
  //       "image/gif",
  //       "image/webp",
  //     ];
  //     if (!allowedTypes.includes(file.type)) {
  //       this.OpenMessage.Openpopup(
  //         "Only JPEG, PNG, GIF, and WebP images are allowed.",
  //       );
  //       event.target.value = "";
  //       return;
  //     }

  //     // Store file for later upload and show preview
  //     this.pageModel.productImageFile = file;
  //     this.pageModel.productImageUrl = "";
  //     const reader = new FileReader();
  //     reader.onload = (e: any) => {
  //       this.pageModel.productImage = e.target.result;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }

  onImageUpload(event: any) {
    const file = event.target.files[0];

    console.log("onImageUpload called:", {
      file: file
        ? {
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified,
          }
        : null,
      eventTargetFiles: event.target.files,
    });

    if (file) {
      const maxSize = 2 * 1024 * 1024; // 2 MB

      if (file.size > maxSize) {
        this.OpenMessage.Openpopup("Image size must not exceed 2 MB.");
        event.target.value = "";
        return;
      }

      const allowedTypes = ["image/jpeg", "image/png", "image/webp"];

      if (!allowedTypes.includes(file.type)) {
        this.OpenMessage.Openpopup(
          "Only JPEG, PNG, and WebP images are allowed.",
        );
        event.target.value = "";
        return;
      }

      this.pageModel.productImageFile = file;
      this.pageModel.productImageUrl = "";

      console.log("File stored in pageModel:", {
        name: this.pageModel.productImageFile.name,
        size: this.pageModel.productImageFile.size,
        type: this.pageModel.productImageFile.type,
      });

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.pageModel.productImage = e.target.result;
        console.log(
          "FileReader completed, data URL length:",
          e.target.result.length,
        );
      };

      reader.onerror = (error) => {
        console.error("FileReader error:", error);
      };

      reader.readAsDataURL(file);
    }
  }


  removeImage() {
    this.pageModel.productImage = "";
    this.pageModel.productImageFile = null;
    this.pageModel.productImagePath = "";
    this.pageModel.productImageUrl = "";
  }

  get borderStyle(): string {
    const menuColor =
      this.currentMerchant?.webapp_settings?.menu_color ??
      this.currentMerchant?.menu_color;

    const borderColor =
      this.currentMerchant?.webapp_settings?.menu_border_color ??
      this.currentMerchant?.menu_border_color;

    const borderWidth =
      this.currentMerchant?.webapp_settings?.menu_border_width ??
      this.currentMerchant?.menu_border_width;

    const style =
      menuColor !== borderColor
        ? `${borderWidth}px solid ${borderColor}`
        : `${borderWidth}px solid`;

    return style;
  }
}
